import { inject, IEventAggregator, bindable } from "aurelia";
import { getLogger } from "../../common/logging";
import { CurrentRoute } from "../../current-route";
import { FormFieldChanged } from "../../messages/form-field-changed";
import { ApplicationTagService } from "../../services/application-tag-service";
import { FormMode } from "../../services/form-mode";
import { elementId } from "../../common/element-id";
let log = getLogger("application-tag");

@inject(Element, IEventAggregator, CurrentRoute, ApplicationTagService, FormMode)
export class ApplicationTagCustomAttribute {
  @bindable value;

  constructor(element, eventAggregator, currentRoute, applicationTagService, formMode) {
    this.element = element;
    this.eventAggregator = eventAggregator;
    this.currentRoute = currentRoute;
    this.service = applicationTagService;
    this.formMode = formMode;
    this.group = null;
    this.validElementTypes = ["checkbox", "select-one", "hidden"];
  }

  attached() {
    this.elementId = elementId(this.element);
    this.elementType = this.element.type;

    if (this.validElementTypes.indexOf(this.elementType) < 0) {
      log.warn(
        `'${this.element.tagName}:[${
          this.elementType
        }]' is not a valid element type. Accepted: [${this.validElementTypes.join(
          ", "
        )}]`
      );
    }

    let groupAttr = this.element.attributes["application-tag-group"];
    if (groupAttr) {
      this.group = groupAttr.value;
    }

    this.applicationId = this.currentRoute.params.id;
    this.subscription = this.eventAggregator.subscribe(
      FormFieldChanged,
      (message) => {
        this.onFormFieldChanged(message);
      }
    );
  }

  detaching() {
    this.subscription.dispose();
  }

  onFormFieldChanged(message) {
    if (message.elementId !== this.elementId || !this.applicationId) return;
    if (this.formMode.readOnly) return;

    if (this.elementType === "checkbox") {
      let tagName = this.value ? this.value : message.name;
      if (message.value) {
        this.service.addTag(
          this.applicationId,
          tagName,
          this.group,
          message.name
        );
      } else {
        this.service.removeTag(this.applicationId, tagName, this.group);
      }
    } else {
      log.info(
        message.oldValue +
          " -> " +
          message.value +
          ", " +
          this.group +
          ", " +
          message.name
      );

      this.service
        .removeTag(this.applicationId, message.oldValue, this.group)
        .then(() => {
          if (!message.value) return;
          this.service.addTag(
            this.applicationId,
            message.value,
            this.group,
            message.name
          );
        });
    }
  }
}
